const basename = __webpack_public_path__.startsWith('http') ? '/' : __webpack_public_path__;

export const config = {
    basename: basename,
};
